import React, { useRef, useState } from 'react'
import Accordion from '../../Accordion/Accordion'
import Field from '../../Field/Field'
import { fieldsTypes } from '../constants'
import { AddInstanceButton, ContextualDropdown, contextualDropdownActionArray, fieldMapper } from '../helper'
import { FieldArray, useField } from 'formik'
import Tooltip from '../../Tooltip/Tooltip'
import Button from '../../Button/Button'
import Icon from '../../Icon2'

const RenderFields = ({ field, onNestedGroupClick, onInstanceClick, currentGroupStack, mode }) => {
  const [groupField, groupMeta] = useField(field.formFieldUid);
  return (
    <>
      {field.multiple
        ? <FieldArray name={field.formFieldUid}>
          {({ insert, remove, move, push }) => (
            <>{currentGroupStack.instanceIndex >= 0
              ? <>
                {currentGroupStack.schema.map((item, index) => {
                  let errorCount = 0
                  if (Array.isArray(groupMeta?.error?.[currentGroupStack.instanceIndex]?.[item.uid])) {
                    // @ts-ignore
                    groupMeta?.error?.[currentGroupStack.instanceIndex]?.[item.uid]?.forEach?.(error => {
                      errorCount++
                    })
                  } else {
                    // @ts-ignore
                    Object.keys(groupMeta?.error?.[currentGroupStack.instanceIndex]?.[item.uid] || {}).forEach(key => {
                      errorCount++
                    })
                  }
                  return (
                    <Field testId={`cs-asset-details-field-${field?.formFieldUid}.${currentGroupStack.instanceIndex}.${item.uid}`} key={item.uid}>
                      {item.type !== fieldsTypes.group
                        ? <>
                          {fieldMapper(item, null, "medium", `${field.formFieldUid}.${currentGroupStack.instanceIndex}`, mode, true)}
                        </>
                        : <div className='group-field-container__nested-group' onClick={() => onNestedGroupClick(item, `${field.formFieldUid}.${currentGroupStack.instanceIndex}.${item.uid}`)} data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${currentGroupStack.instanceIndex}.${item.uid}-group-accordion-nested-group-header`}>
                          <div className='flex-justify group-field-container__nested-group-header'>
                            <div className='flex group-field-container__nested-group-header-title'>
                              <div className='group-field-container__nested-group-header-title-label' data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${currentGroupStack.instanceIndex}.${item.uid}-group-accordion-nested-group-header-title-label`}>{item.title}</div>
                              <div className='group-field-container__nested-group-header-title-count' data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${currentGroupStack.instanceIndex}.${item.uid}-group-accordion-nested-group-header-title-count`}>{item.multiple ? (groupField?.value?.[currentGroupStack.instanceIndex]?.[item.uid]?.length) : item?.schema?.length} sub-fields
                              </div>
                              {errorCount
                                ? <div className='group-field-container__nested-group-header-title-error' data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${currentGroupStack.instanceIndex}.${item.uid}-group-accordion-nested-group-header-title-error`}>
                                  <Icon icon="CloseBorder" version='v2' />
                                  {errorCount} {errorCount > 1 ? 'errors' : 'error'}</div>
                                : null}
                            </div>
                            <Tooltip content={`Open Instance`} position="top" showArrow={false}
                              variantType='dark'
                              type="secondary"
                              // className='font-size-small' 
                              testId={`cs-asset-details-field-${field?.formFieldUid}.${currentGroupStack.instanceIndex}.${item.uid}-group-accordion-nested-group-header-title-error-tooltip`}>
                              <Button testId={`cs-asset-details-field-${field?.formFieldUid}.${currentGroupStack.instanceIndex}.${item.uid}-group-accordion-nested-group-header-title-error-icon`} tabIndex={0} onlyIcon={true} iconProps={{ size: 'small' }} onlyIconHoverColor="primary" version="v2" icon="v2-CaretRight" />
                            </Tooltip>
                          </div>
                        </div>
                      }
                    </Field>)
                })}
              </>
              : <>
                {groupField?.value?.map((item, index) => {
                  let errorCount = 0
                  if (Array.isArray(groupMeta?.error?.[index])) {
                    // @ts-ignore
                    groupMeta?.error?.[index]?.forEach?.(error => {
                      errorCount++
                    })
                  } else {
                    // @ts-ignore
                    Object.keys(groupMeta?.error?.[index] || {}).forEach(key => {
                      errorCount++
                    })
                  }

                  return (
                    <div className='group-field-container__nested-group' onClick={() => onInstanceClick(field, index)} data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${index}-group-accordion-nested-group-header`}>
                      <div className='flex-justify group-field-container__nested-group-header'>
                        <div className='flex group-field-container__nested-group-header-title'>
                          <div className='group-field-container__nested-group-header-title-label' data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${index}-group-accordion-nested-group-header-title-label`}>Instance {index + 1}</div>
                          {errorCount
                            ? <div className='group-field-container__nested-group-header-title-error flex-v-center' data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${index}-group-accordion-nested-group-header-title-error`}>
                              <Icon icon="CloseBorder" version='v2' size='small' testId={`cs-asset-details-field-${field?.formFieldUid}.${index}-group-accordion-nested-group-header-title-error-icon`} />
                              <div className='ml-5' data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${index}-group-accordion-nested-group-header-title-error-count`}>{errorCount} {errorCount > 1 ? 'errors' : 'error'}</div>
                            </div>
                            : null}
                        </div>
                        <div className='group-field-multiple-instance-actions-dropdown' data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${index}-group-accordion-nested-group-header-actions-dropdown`}>
                          <ContextualDropdown contextualDropdownActionArray={contextualDropdownActionArray(field, index, remove)} field={field} />
                          <Tooltip content={`Open Instance`} position="top" showArrow={false} variantType='dark'
                            type="secondary"
                            //  className='font-size-small' 
                            testId={`cs-asset-details-field-${field?.formFieldUid}.${index}-group-accordion-nested-group-header-title-error-tooltip`}>
                            <Button testId={`cs-asset-details-field-${field?.formFieldUid}.${index}-group-accordion-nested-group-header-title-error-icon`} tabIndex={0} onlyIcon={true} iconProps={{ size: 'small' }} onlyIconHoverColor="primary" version="v2" icon="v2-CaretRight" />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  )
                })}
                <AddInstanceButton field={field} valueLength={groupField?.value?.length} push={push} />
              </>
            }</>
          )}
        </FieldArray>
        : <>
          {currentGroupStack.schema.map((item) => {
            let errorCount = 0
            if (Array.isArray(groupMeta?.error?.[item.uid])) {
              // @ts-ignore
              groupMeta?.error?.[item.uid]?.forEach?.(error => {
                errorCount++
              })
            } else {
              // @ts-ignore
              Object.keys(groupMeta?.error?.[item.uid] || {}).forEach(key => {
                errorCount++
              })
            }
            return (
              <Field testId={`cs-asset-details-field-${field?.formFieldUid}.${item.uid}`} key={item.uid}>
                {item.type !== fieldsTypes.group
                  ? <>
                    {fieldMapper(item, null, "medium", `${field.formFieldUid}`, mode, true)}
                  </>
                  : <div className='group-field-container__nested-group' onClick={() => onNestedGroupClick(item, `${field.formFieldUid}.${item.uid}`)} data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${item.uid}-group-accordion-nested-group-header`}>
                    <div className='flex-justify group-field-container__nested-group-header'>
                      <div className='flex group-field-container__nested-group-header-title'>
                        <div className='group-field-container__nested-group-header-title-label' data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${item.uid}-group-accordion-nested-group-header-title-label`}>{item.title}</div>
                        <div className='group-field-container__nested-group-header-title-count' data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${item.uid}-group-accordion-nested-group-header-title-count`}>{item?.schema?.length} sub-fields
                        </div>
                        {errorCount
                          ? <div className='group-field-container__nested-group-header-title-error flex-v-center' data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${item.uid}-group-accordion-nested-group-header-title-error`}>
                            <Icon icon="CloseBorder" version='v2' size='small' testId={`cs-asset-details-field-${field?.formFieldUid}.${item.uid}-group-accordion-nested-group-header-title-error-icon`} />
                            <div className='ml-5' data-test-id={`cs-asset-details-field-${field?.formFieldUid}.${item.uid}-group-accordion-nested-group-header-title-error-count`}>{errorCount} {errorCount > 1 ? 'errors' : 'error'}</div>

                          </div>
                          : null}
                      </div>
                      <Tooltip content={`Open Instance`} position="top" showArrow={false}
                        variantType='dark'
                        type="secondary"
                        //  className='font-size-small'
                        testId={`cs-asset-details-field-${field?.formFieldUid}.${item.uid}-group-accordion-nested-group-header-title-error-tooltip`}>
                        <Button testId={`cs-asset-details-field-${field?.formFieldUid}.${item.uid}-group-accordion-nested-group-header-title-error-icon`} tabIndex={0} onlyIcon={true} iconProps={{ size: 'small' }} onlyIconHoverColor="primary" version="v2" icon="v2-CaretRight" />
                      </Tooltip>
                    </div>
                  </div>
                }
              </Field>)
          })}
        </>}
    </>
  )
}

const Group = (props) => {
  const { field, boundaryRef, mode } = props

  const [groupField, groupMeta] = useField(field.formFieldUid);

  const [groupStack, setGroupStack] = useState([
    {
      title: field.title,
      parentData: {},
      field: field,
      schema: field.schema,
      showBackButton: false,
      subTitle: field.title,
      multiple: field.multiple,
      instanceIndex: -1,
    }
  ])

  const onNestedGroupClick = (field, formFieldUid) => {
    field.formFieldUid = `${formFieldUid}`
    setGroupStack([...groupStack, {
      title: groupStack[groupStack.length - 1]?.subTitle,
      parentData: {},
      field: field,
      schema: field.schema,
      showBackButton: true,
      subTitle: field.title,
      multiple: field.multiple,
      instanceIndex: -1,
    }])
  }

  const onInstanceClick = (field, index) => {
    setGroupStack([...groupStack, {
      title: groupStack[groupStack.length - 1]?.subTitle,
      parentData: {},
      field: field,
      schema: field.schema,
      showBackButton: true,
      subTitle: ` ${groupStack[groupStack.length - 1]?.subTitle}`,
      multiple: field.multiple,
      instanceIndex: index,
    }])
  }

  const onPopoverClose = () => {
    setGroupStack([{
      title: field.title,
      parentData: {},
      field: field,
      schema: field.schema,
      showBackButton: false,
      subTitle: field.title,
      multiple: field.multiple,
      instanceIndex: -1,
    }])
  }

  const onBackButtonClick = () => {
    setGroupStack(groupStack.slice(0, -1))
  }

  const closePopoverCallBkRef = { callbk: () => null }

  let errorCount = 0
  if (Array.isArray(groupMeta?.error)) {
    // @ts-ignore
    groupMeta.error.forEach(error => {
      errorCount++
    })
  } else {
    // @ts-ignore
    Object.keys(groupMeta?.error || {}).forEach(key => {
      errorCount++
    })
  }

  return <div ref={boundaryRef}>
    <Accordion
      title={field.title}
      accordionDataCount={field.multiple ? groupField?.value?.length : field.schema?.length}
      errorMessage={(errorCount > 0 && groupMeta.touched) ? `${errorCount} errors` : ''}
      version={'v2'}
      isContextualPopover={true}
      boundaryRef={boundaryRef}
      onPopoverClose={onPopoverClose}
      popoverWidth={400}
      testId={`cs-asset-details-field-${field?.formFieldUid}-group-accordion`}
      closePopoverCallBkRef={closePopoverCallBkRef}
    >
      <div className="asset-details-v2-fields-container__group-field-container" data-test-id={`cs-asset-details-field-${field?.formFieldUid}-group-accordion-content`}>
        <div className='flex-justify mb-10 group-field-container__header' style={{ fontFamily: 'Inter', fontSize: '14px' }}>
          <div className='flex-v-center group-field-container__header-title' data-test-id={`cs-asset-details-field-${field?.formFieldUid}-group-accordion-header-title`}>
            {groupStack[groupStack.length - 1]?.showBackButton
              ? <Tooltip content={`Go Back`} position="top" showArrow={false}
                // className='font-size-small' 
                variantType='dark'
                type="secondary"
                testId={`cs-asset-details-field-${field?.formFieldUid}-group-accordion-back-action-tooltip`}>
                <Button testId={`cs-asset-details-field-${field?.formFieldUid}-group-accordion-back-action-icon`} tabIndex={0} onlyIcon={true} iconProps={{ size: 'small' }} onlyIconHoverColor="primary" version="v2" icon="v2-CaretLeft" onClick={onBackButtonClick} />
              </Tooltip>
              : null}
            <div className='font-semi-bold group-field-container__title'>{groupStack[groupStack.length - 1]?.title}</div>
          </div>
          <Tooltip content={`Close`} position="top" showArrow={false}
            // className='font-size-small'
            variantType='dark'
            type="secondary"
            testId={`cs-asset-details-field-${field?.formFieldUid}-group-accordion-close-action-tooltip`}>
            <Button testId={`cs-asset-details-field-${field?.formFieldUid}-group-accordion-close-action-icon`} tabIndex={0} onlyIcon={true} onlyIconHoverColor="primary" version="v2" icon="v2-CloseNoborder" iconProps={{ size: 'small' }} onClick={() => {
              closePopoverCallBkRef?.callbk()
            }} />
          </Tooltip>
        </div>
        {(groupStack[groupStack.length - 1]?.subTitle && groupStack.length > 1)
          ? <div className='font-semi-bold group-field-container__sub-title' data-test-id={`cs-asset-details-field-${field?.formFieldUid}-group-accordion-sub-title-${groupStack[groupStack.length - 1]?.instanceIndex >= 0 ? groupStack[groupStack.length - 1]?.instanceIndex + 1 : groupStack[groupStack.length - 1]?.subTitle}`}>
            {groupStack[groupStack.length - 1]?.instanceIndex >= 0 ? `Instance ${groupStack[groupStack.length - 1]?.instanceIndex + 1}`
              : groupStack[groupStack.length - 1]?.subTitle}
          </div> : null}
        <RenderFields field={groupStack[groupStack.length - 1]?.field} onNestedGroupClick={onNestedGroupClick} onInstanceClick={onInstanceClick} currentGroupStack={groupStack[groupStack.length - 1]} mode={mode} />
      </div>
    </Accordion>
  </div>
}

export default Group